import { useState, ReactNode } from 'react';
import ConfirmModal from '../ConfirmModal';

type Pending = { title: string; message: ReactNode; confirmLabel: string; onConfirm: () => void };

// Shared confirmation dialog for destructive admin actions. Returns `ask(...)`
// to trigger a confirm and `confirmModal` to render once per page — so every
// console gets the same ConfirmModal UX instead of bare window.confirm / no guard.
export function useConfirm() {
    const [pending, setPending] = useState<Pending | null>(null);

    const ask = (message: ReactNode, onConfirm: () => void, opts?: { title?: string; confirmLabel?: string }) =>
        setPending({ message, onConfirm, title: opts?.title ?? "Opravdu?", confirmLabel: opts?.confirmLabel ?? "Smazat" });

    const confirmModal = (
        <ConfirmModal
            open={!!pending}
            title={pending?.title}
            message={pending?.message ?? ""}
            confirmLabel={pending?.confirmLabel}
            cancelLabel="Zrušit"
            onConfirm={() => { pending?.onConfirm(); setPending(null); }}
            onClose={() => setPending(null)}
        />
    );

    return { ask, confirmModal };
}
